import React, { useEffect } from 'react';
import Card from '../Card';
import FunFact from '../FunFact';
import Hero from '../Hero';
import Div from '../Div';
import SectionHeading from '../SectionHeading';
import Spacing from '../Spacing';
import Cta from '../Cta';
import LogoList from '../LogoList';
import MovingText from '../MovingText';
import PortfolioSlider from '../Slider/PortfolioSlider';
import TestimonialSlider from '../Slider/TestimonialSlider';
import TeamSlider from '../Slider/TeamSlider';
import VideoModal from '../VideoModal';
import { pageTitle } from '../../helper';
// Hero Social Links
const heroSocialLinks = [
  {
    name: 'Behance',
    links: '/',
  },
  {
    name: 'Twitter',
    links: '/',
  },
];

// FunFact Data
const funfaceData = [
  {
    title: 'Successful Projects',
    factNumber: '150+',
  },
  {
    title: 'Satisfied Clients',
    factNumber: '80+',
  },
  {
    title: 'Expert Developers',
    factNumber: '25+',
  },
  {
    title: 'Years of Experience',
    factNumber: '8+',
  },
];
const journeyData = [
  { year: '2018', name: 'Custom Software', description: 'Started building custom software solutions' },
  { year: '2019', name: 'Mobile Development', description: 'Expanded into mobile app development' },
  { year: '2020', name: 'E-Commerce & Payments', description: 'Delivered e-commerce and payment-enabled platforms' },
  { year: '2021', name: 'Enterprise Automation', description: 'Built enterprise automation systems' },
  { year: '2022', name: 'Fintech & Wallets', description: 'Entered fintech and wallet solutions' },
  { year: '2023', name: 'Multi-Service Platforms', description: 'Developed scalable multi-service platforms' },
  { year: '2024', name: 'Industry Integrations', description: 'Expanded integrations across industries' },
  { year: '2025', name: 'Secure Systems', description: 'Focused on secure, production-ready systems' },
  { year: '2026', name: 'Global Scaling', description: 'Scaling delivery for regional & global clients' },
];

const portfolioData = [
  {
    title: 'GreenPay Digital Wallet',
    subtitle: 'Super App Platform',
    href: '/portfolio/greenpay-wallet',
    src: '/images/greenpay-wallet-app.png',
  },
  {
    title: 'TOXO Rider App',
    subtitle: 'Taxi Passenger Mobile Application',
    href: '/portfolio/toxo-rider',
    src: '/images/toxo-rider-app.png',
  },
  {
    title: 'TOXO Driver App',
    subtitle: 'Taxi Driver Mobile Application',
    href: '/portfolio/toxo-driver',
    src: '/images/toxo-driver-app.png',
  },
  {
    title: 'Raffe App',
    subtitle: 'Digital Raffles & Prize Campaigns',
    href: '/portfolio/raffe-app',
    src: '/images/raffe-app.png',
  },
  {
    title: 'Online Reservation Platform',
    subtitle: 'Service Businesses (Web & Mobile)',
    href: '/portfolio/reservation-platform',
    src: '/images/online-reservation-platform.png',
  },
  {
    title: 'PFL Platform',
    subtitle: 'Azerbaijan Professional Football League',
    href: '/portfolio/pfl-website',
    src: '/images/pfl-website.png',
  },
];

export default function Home() {
  pageTitle('Home');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* Start Hero Section */}
      <Hero
        title="TUR DER HOFFNUNG <br/>Merchant Services"
        subtitle="Trusted merchant operations, secure hosted payments, and clear customer support information."
        btnText="Get a Quote"
        btnLink="/contact"
        scrollDownId="#service"
        socialLinksHeading="Follow Us"
        heroSocialLinks={heroSocialLinks}
        bgImageUrl="/images/hero_bg.jpeg"
      />
      {/* End Hero Section */}

      {/* Start FunFact Section */}
      <div className="container">
        <FunFact
          variant="cs-type1"
          title="Why TUR DER HOFFNUNG"
          subtitle="We focus on clear merchant communication, secure hosted checkout flows, and reliable customer service across every payment touchpoint."
          data={funfaceData}
        />
      </div>
      {/* End FunFact Section */}

      {/* Start Service Section */}
      <Spacing lg="150" md="80" />
      <Div id="service">
        <Div className="container">
          <Div className="row">
            <Div className="col-xl-4">
              <SectionHeading
                title="We Are Experts In These Services"
                subtitle="What Can We Do"
                btnText="See All Services"
                btnLink="/service"
              />
              <Spacing lg="90" md="45" />
            </Div>
            <Div className="col-xl-8">
              <Div className="row">
                <Div className="col-lg-3 col-sm-6 cs-hidden_mobile"></Div>
                <Div className="col-lg-3 col-sm-6">
                  <Card
                    title="Web Solutions"
                    link="/service/service-details"
                    src="/images/service_1.jpeg"
                    alt="Service"
                  />
                  <Spacing lg="0" md="30" />
                </Div>
                <Div className="col-lg-3 col-sm-6 cs-hidden_mobile"></Div>
                <Div className="col-lg-3 col-sm-6">
                  <Card
                    title="Mobile Solutions"
                    link="/service/service-details"
                    src="/images/service_2.jpeg"
                    alt="Service"
                  />
                  <Spacing lg="0" md="30" />
                </Div>
                <Div className="col-lg-3 col-sm-6">
                  <Card
                    title="Enterprise Solutions"
                    link="/service/service-details"
                    src="/images/service_3.jpeg"
                    alt="Service"
                  />
                  <Spacing lg="0" md="30" />
                </Div>
                <Div className="col-lg-3 col-sm-6 cs-hidden_mobile"></Div>
                <Div className="col-lg-3 col-sm-6">
                  <Card
                    title="Other IT Solutions"
                    link="/service/service-details"
                    src="/images/service_4.jpeg"
                    alt="Service"
                  />
                  <Spacing lg="0" md="30" />
                </Div>
              </Div>
            </Div>
          </Div>
        </Div>
      </Div>
      {/* End Service Section */}

      {/* Start Portfolio Section */}
      <Spacing lg="150" md="50" />
      <Div>
        <Div className="container">
          <SectionHeading
            title="Portfolio to explore"
            subtitle="Latest Projects"
            variant="cs-style1 text-center"
          />
          <Spacing lg="90" md="45" />
        </Div>
        <PortfolioSlider data={portfolioData} />
      </Div>
      {/* End Portfolio Section */}

      {/* Start Journey Section */}
      <Spacing lg="150" md="80" />
      <Div className="cs-shape_wrap_2">
        <Div className="cs-shape_2">
          <Div />
        </Div>
        <Div className="container">
          <SectionHeading
            title="Our Journey (2018–Today)"
            subtitle="Milestones"
            variant="cs-style1 text-center"
          />
          <Spacing lg="60" md="30" />
          <Div className="row">
            {journeyData.map((item, index) => (
              <Div className="col-lg-4 col-sm-6" key={index}>
                <Div className="cs-time_line cs-style1" style={{marginBottom: '40px'}}>
                  <h3 className="cs-accent_color">{item.year}</h3>
                  <h2>{item.name}</h2>
                  <p>{item.description}</p>
                </Div>
              </Div>
            ))}
          </Div>
        </Div>
      </Div>
      {/* End Journey Section */}

      {/* Start Video Block Section */}
      <Spacing lg="130" md="70" />
      <Div className="container">
        <h2 className="cs-font_50 cs-m0 text-center cs-line_height_4">
          Our agile process is ability to adapt and respond to change. Agile
          organizations view change as an opportunity, not a threat.
        </h2>
        <Spacing lg="70" md="70" />
        <VideoModal
          videoSrc="https://www.youtube.com/watch?v=VcaAVWtP48A"
          bgUrl="/images/video_bg.jpeg"
        />
      </Div>
      {/* End Video Block Section */}

      {/* Start Team Section */}
      <Spacing lg="145" md="80" />
      <Div className="container">
        <SectionHeading
          title="Awesome team <br/>members"
          subtitle="Our Team"
          variant="cs-style1"
        />
        <Spacing lg="85" md="45" />
        <TeamSlider />
      </Div>
      <Spacing lg="150" md="80" />
      {/* End Team Section */}

      {/* Start Testimonial Section */}
      <TestimonialSlider />
      {/* End Testimonial Section */}


      {/* Start Technologies Section */}
      <Spacing lg="125" md="70" />
      <MovingText text="Technologies We Use" />
      <Spacing lg="105" md="70" />

      <Div className="container">
        <LogoList />
      </Div>
      <Spacing lg="150" md="80" />
      {/* End Technologies Section */}

      {/* Start CTA Section */}
      <Div className="container">
        <Cta
          title="Let’s disscuse make <br />something <i>cool</i> together"
          btnText="Apply For Meeting"
          btnLink="/contact"
          bgSrc="/images/cta_bg.jpeg"
        />
      </Div>
      {/* End CTA Section */}
    </>
  );
}
